/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetAdminCompetitionAuditRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetAdminCompetitionAuditArgs, useGetAdminCompetitionAuditSpec, useGetAdminCompetitionAuditRealtime, useGetAdminCompetitionAuditPagination } from '../specs/admin.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetAdminCompetitionAuditRow } from '../openapi-types.gen.js';
export type { useGetAdminCompetitionAuditArgs } from '../specs/admin.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetAdminCompetitionAuditPaginationContract = useGetAdminCompetitionAuditPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetAdminCompetitionAuditInfinite` — both
 * read/write the same `PagedData<GetAdminCompetitionAuditRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): competitionId.
 */
const _useGetAdminCompetitionAudit = createListHook({
  spec: useGetAdminCompetitionAuditSpec,
  realtime: useGetAdminCompetitionAuditRealtime,
  entityKey: null,
  pagination: _useGetAdminCompetitionAuditPaginationContract,
});
export const useGetAdminCompetitionAudit = _useGetAdminCompetitionAudit as (args: useGetAdminCompetitionAuditArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminCompetitionAudit>;


/**
 * Auto-infinite: same cache as `useGetAdminCompetitionAudit`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetAdminCompetitionAudit` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetAdminCompetitionAuditInfinite = createListHook({
  spec: useGetAdminCompetitionAuditSpec,
  realtime: useGetAdminCompetitionAuditRealtime,
  entityKey: null,
  pagination: _useGetAdminCompetitionAuditPaginationContract,
  autoLoadMore: true,
});
export const useGetAdminCompetitionAuditInfinite = _useGetAdminCompetitionAuditInfinite as (args: useGetAdminCompetitionAuditArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetAdminCompetitionAuditInfinite>;


/**
 * Per-field subscription hook for the `useGetAdminCompetitionAudit` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetAdminCompetitionAuditField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetAdminCompetitionAuditField = createFieldHook<GetAdminCompetitionAuditRow>('useGetAdminCompetitionAuditField');

/**
 * Hover/intent prefetch companion for `useGetAdminCompetitionAudit` (also covers
 * `useGetAdminCompetitionAuditInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetAdminCompetitionAudit();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetAdminCompetitionAudit = createPrefetchHook(useGetAdminCompetitionAuditSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetAdminCompetitionAuditArgs>;
